import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import axios, { API } from "@/lib/api";

function timeAgo(d) {
  const diff = (Date.now() - new Date(d).getTime()) / 1000;
  if (diff < 60) return "Baru saja";
  if (diff < 3600) return `${Math.floor(diff / 60)} menit lalu`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} jam lalu`;
  return `${Math.floor(diff / 86400)} hari lalu`;
}

export default function NotificationBell() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const load = () => axios.get(`${API}/jamaah/notifikasi`).then(({ data }) => setItems(data)).catch(() => {});

  useEffect(() => { load(); }, []);

  const unread = items.filter((i) => !i.is_read).length;

  const markAllRead = async () => {
    await axios.put(`${API}/jamaah/notifikasi/read-all`);
    load();
  };

  return (
    <Popover open={open} onOpenChange={(v) => { setOpen(v); if (v) load(); }}>
      <PopoverTrigger asChild>
        <button data-testid="notification-bell-button" className="relative flex h-10 w-10 items-center justify-center rounded-full text-[#1F2937] hover:bg-[#0F6B4F]/10">
          <Bell className="h-5 w-5" />
          {unread > 0 && (
            <span data-testid="notification-unread-count" className="absolute right-1.5 top-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white">
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 rounded-2xl p-0">
        <div className="flex items-center justify-between border-b border-slate-100 p-4">
          <p className="font-heading text-sm font-semibold text-[#1F2937]">Notifikasi</p>
          {unread > 0 && (
            <button data-testid="notification-mark-all-read" onClick={markAllRead} className="text-xs font-medium text-[#0F6B4F] hover:underline">
              Tandai semua dibaca
            </button>
          )}
        </div>
        <div className="max-h-80 overflow-y-auto">
          {items.length === 0 ? (
            <p className="p-6 text-center text-sm text-[#64748B]">Belum ada notifikasi</p>
          ) : (
            items.slice(0, 15).map((n) => (
              <div key={n.id} data-testid={`notification-item-${n.id}`} className={`border-b border-slate-50 p-4 text-sm ${!n.is_read ? "bg-[#0F6B4F]/5" : ""}`}>
                <p className="font-medium text-[#1F2937]">{n.title}</p>
                <p className="mt-1 text-xs text-[#64748B] line-clamp-2">{n.message}</p>
                <p className="mt-1 text-xs text-[#94a3b8]">{timeAgo(n.created_at)}</p>
              </div>
            ))
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
